module.exports = __webpack_public_path__ + "toBride2-jp-r-b.d8738942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-jp-r-b.jpg
// module id = ttpw
// module chunks = 0